/*
 *
 * Authorization API Request Methods
 *
 */

import request from 'utils/request';
import { URL } from './constants';

export function apiRequest(method, payload) {
  const options = {
    method,
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
    body: JSON.stringify(payload),
  };
  return request(URL, options);
}

export default apiRequest;



// WEBPACK FOOTER //
// ./src/services/SsoLogin/api.js